import i18n from '@/configs/i18n'

export const httpsStatus = {
  expired: 401,
}
export const errorCode = {
  tokenExpired: 20011,
}
export const genderOptions = [
  { value: 'FEMALE', label: i18n.t('common.gender.female') },
  { value: 'MALE', label: i18n.t('common.gender.male') },
]

export const drawerQuery = {
  addBranch: 'add-branch',
}

export const FORMAT_DATE = 'DD MMM YYYY'

export const GENDER_ALL_OPTIONS = [
  { value: 'ALL', label: i18n.t('common.all') },
  { value: 'FEMALE', label: i18n.t('common.gender.female') },
  { value: 'MALE', label: i18n.t('common.gender.male') },
]

export const TIMEZONE = [
  {
    label: 'Waktu Indonesia Barat (WIB)',
    value: 'Asia/Jakarta',
  },
  {
    label: 'Waktu Indonesia Tengah (WITA)',
    value: 'Asia/Makassar',
  },
  {
    label: 'Waktu Indonesia Timur (WIT)',
    value: 'Asia/Jayapura',
  },
]

export const days = [
  {
    label: i18n.t('common.schedule.days.mon'),
    value: 'Mon',
  },
  {
    label: i18n.t('common.schedule.days.tue'),
    value: 'Tue',
  },
  {
    label: i18n.t('common.schedule.days.wed'),
    value: 'Wed',
  },
  {
    label: i18n.t('common.schedule.days.thus'),
    value: 'Thu',
  },
  {
    label: i18n.t('common.schedule.days.fri'),
    value: 'Fri',
  },
  {
    label: i18n.t('common.schedule.days.sat'),
    value: 'Sat',
  },
  {
    label: i18n.t('common.schedule.days.sun'),
    value: 'Sun',
  },
]

export const imageFileTypes = ['image/png', 'image/jpeg', 'image/jpg']

export const defaultCountry = {
  name: 'Indonesia',
  dial_code: '+62',
  emoji: '🇮🇩',
  code: 'ID',
}
export const allScopesCharges = ['SERVICE', 'PRODUCT', 'PACKAGE', 'VOUCHER']

export const maxImageProduct = 6

export const maxServicePhoto = 1

export const maxServicePhotoSizeMB = 1

export const paymentClientWalletId = '32119701-1064-47bb-a4b7-8a107c0c6114'
export const paymentDynamicQrisId = '5cce1817-db43-4faa-a00d-ad42f6c75b09'
export const paymentClientCashId = '8a898f27-85aa-4509-ac22-824fe6ee9b5f'
export const dummyEmailDomain = '@dummy.com'
export const errorTransactionAlreadyCheckout = 'TRANSACTION_CANNOT_UPDATE'
export const errorAttendanceInvalidPhoto = 'Invalid Photo'
